module.exports = __webpack_public_path__ + "static/media/ZA.4b07683a.svg";